import { useContext, useEffect, useState } from "react";
import { SortingRule } from "react-table";
import { Button, useTitle } from "modules/common";
import { MobileApp, GetMobileAppRequest } from "services/mobileAppsPortal";
import { MobileAppDetailsModal, MobileAppsTable, useGetMobileApps } from "modules/mobileAppsPortal";
import { AccessibilityContext } from "./AccessibilityContext";

const initialRequest: GetMobileAppRequest = {
    page: 1,
    pageSize: 10,
};

export const MobileAppsPortal = () => {
    useTitle("Portal mobilnih aplikacija - eSavjetnik");
    const [request, setRequest] = useState<GetMobileAppRequest>(initialRequest);
    const [selectedMobileApp, setSelectedMobileApp] = useState<MobileApp>();
    const [sortBy, setSortBy] = useState<SortingRule<object>>();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { data: mobileApps, isLoading } = useGetMobileApps(request);

    useEffect(() => {
        setRequest(prev => ({
            ...prev,
            sortField: sortBy?.id,
            descending: sortBy?.desc,
        }));
    }, [sortBy]);

    const handlePageSizeChange = (value: number) => {
        setRequest(prev => ({ ...prev, page: 1, pageSize: value }));
    };

    const handlePageChange = (value: number) => {
        setRequest(prev => ({ ...prev, page: value }));
    };

    const handleRowSelect = (row: MobileApp) => {
        setSelectedMobileApp(row);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedMobileApp(undefined);
    };
     const { lowVision } = useContext(AccessibilityContext);
    return (
        <div className="mobile-apps-portal">
            <div className="mobile-apps-portal-heading">
                <div className="mobile-apps-portal-filters">
                    <span>MOBILNE APLIKACIJE</span>
                </div>
                <Button
                    size="small"
                    className="mobile-apps-portal-button"
                    variant="primary"
                    lowVision={lowVision}
                    onClick={() => setIsModalOpen(true)}
                >
                    KREIRAJ NOVU
                </Button>
            </div>
            <MobileAppsTable
                mobileApps={mobileApps}
                isLoading={isLoading}
                setSortBy={setSortBy}
                page={request.page}
                pageSize={request.pageSize}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePageChange}
                onRowSelect={handleRowSelect}
            />
            <MobileAppDetailsModal
                selectedMobileApp={selectedMobileApp}
                isOpen={isModalOpen}
                handleClose={closeModal}
                page={request.page}
                onPageChange={handlePageChange}
            />
        </div>
    );
};
